<template>
  <v-card flat>
    <v-card-text class="report-page content-500">
      <h2 class="page-title">Sync Status</h2>
      <p class="text-xs-center"><em>The reports below have not been properly synced to the server.</em></p>

      <div class="text-xs-center">
        <v-btn
          @click="$syncService.sync()"
          :disabled="!items.length"
          color="success"
          class="btn__sync_all"
        >
          <v-icon left>sync</v-icon>
          <span class="btn__text">Sync All</span>
        </v-btn>
      </div>

      <v-list two-line>

          <template v-for="(item, index) in items">
            <v-list-tile v-bind:key="index" class="field px-0">

              <v-list-tile-content>
                <v-list-tile-title>{{ item.room_id }}</v-list-tile-title>
                <v-list-tile-sub-title class="grey--text text--darken-4">Last attempted at {{ item.lastSent | date }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn
                  v-bind:color="syncStatusIcons[item.status].color"
                  flat
                  round
                  icon
                  @click="$syncService.sync(item)"
                >
                  <v-icon>sync</v-icon>
                </v-btn>
              </v-list-tile-action>

            </v-list-tile>
            <v-divider v-if="index + 1 < $syncService.items.length"></v-divider>
          </template>

      </v-list>
    </v-card-text>

  </v-card>
</template>

<style>
li.px-0 > .list__tile {
  padding: 0;
}
</style>

<script>
// TODO: Color code sync buttons for each row based on status
import Vue from 'vue';

import moment from 'moment'

export default {
  name: 'sync',
  data() {
    return {
      syncStatusIcons: { // TODO: Move item & queue status icons/colors into syncService
        pending: {
          color: 'warning',
          icon: 'sync'
        },
        sending: {
          color: 'secondary',
          icon: 'sync'
        },
        failed: {
          color: 'error',
          icon: 'sync'
        },
        success: {
          color: 'success',
          icon: 'sync'
        }
      }
    };
  },
  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  computed: {
    items () {
      return this.$syncService.items.filter(it => it.teamId === this.teamId);
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    add(item){
      this.$syncService.add(item);
    },
    resetSyncStore(){
      this.$syncService.clearQueue()
    },
    loadData() {
    }
  },
  filters: {
    date(timestamp) {
      return moment(timestamp, 'x').format('MM/DD/YYYY h:mma');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Sync.vue